var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "renew-tile",
      on: {
        click: function click($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "tile-header"
        },
        [
          _c(
            "div",
            {
              staticClass: "plan-name"
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.service.name))]),
              _c(
                "v-icon",
                {
                  staticClass: "flag-icon",
                  attrs: {
                    small: ""
                  }
                },
                [_vm._v(_vm._s(_vm.iconFlag(_vm.service.flag)))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "tile-body"
        },
        [
          _c(
            "div",
            {
              staticClass: "domain-name"
            },
            [_vm._v(_vm._s(_vm.service.domain))]
          ),
          _c(
            "div",
            {
              staticClass: "renewal-info"
            },
            [
              _c(
                "div",
                {
                  staticClass: "info-row"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "info-label"
                    },
                    [_vm._v("Billing Cycle")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "info-value"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.capitalizeFirst(_vm.service.renewalterm))
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "info-row"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "info-label"
                    },
                    [_vm._v("Next Renewal")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "info-value"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatRenewalDate(
                            _vm.parseRenewalDate(_vm.service.renewaldate)
                          )
                        )
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "info-row"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "info-label"
                    },
                    [_vm._v("Renewal Cost")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "info-value"
                    },
                    [
                      _vm._v(
                        "$" +
                          _vm._s(parseFloat(_vm.service.renewalcost).toFixed(2))
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "tile-footer"
        },
        [
          _c(
            "button",
            {
              staticClass: "renew-btn"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-1",
                  attrs: {
                    small: ""
                  }
                },
                [_vm._v("mdi-refresh")]
              ),
              _vm._v(" Renewal Options ")
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }